import { get } from 'lodash';
import { connect } from 'react-redux';

import VisitorTableComponent from './VisitorTableComponent';

import { SET_LIST_PARAMS } from '../../actionConstants';
import { getVisitorsListByCreatorId } from './actionCreators';

import { getTodayCount } from '../../utils';

const LIST_KEY = 'visitorProfilePT';

const mapStateToProps = (state) => {
  const { visitors, lists } = state;
  return {
    items: visitors?.visitorsInfo || {},
    listKey: LIST_KEY,
    listParams: lists?.[LIST_KEY] || {},
    isVisitorProfile: true,
    isInviteModalShown: false,
    onLogEntry: () => null,
    deleteInvite: () => null,
    onCloseInviteModal: () => null,
    onShowInviteModal: () => null,
    sendInvite: () => null,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad: () => {},
  getItems: (queryParams = {}) => {
    const ownQueryParams = queryParams;
    ownQueryParams.creator_id = get(ownProps, 'visitorId');
    ownQueryParams.role = 10;
    getVisitorsListByCreatorId(
      dispatch,
      ownQueryParams,
      get(ownProps, 'visitorId'),
    );
    getTodayCount(getVisitorsListByCreatorId, dispatch, ownQueryParams);
  },
  setListParams: (queryParams) =>
    dispatch({
      type: SET_LIST_PARAMS,
      listKey: LIST_KEY,
      queryParams,
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitorTableComponent);
